import React from "react";
import "../styles/spinner.css"; // Importa los estilos

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="loader"></div>
    </div>
  );
};

export default Spinner;
